/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dialog_Credentials_HeadingInputs */



/**
* | output |
* | --- |
* | "Credentials" |
*
* @param {Integrations_Dialog_Credentials_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dialog_credentials_heading = /** @type {((inputs?: Integrations_Dialog_Credentials_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dialog_Credentials_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugangsdaten")
	return /** @type {LocalizedString} */ ("Credentials")
});